import React, { useContext } from 'react';
import { DateRange } from '@spa/shared/';
import Group from '@spa/shared/components/Filters/Group';
import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { FiltersContext, FiltersReducerActions } from '@spa/shared/contexts/filters';
import { useRouter } from 'next/router';

const barcelona = 'barcelona';

const Dates = ({ fields, onMultiChangeHandler, onChangeEventHandler }) => {
  const { params } = useRouter();
  const { t } = useTranslation('translations');
  const {
    filters: { shouldOpenDatesFilter },
    dispatch
  } = useContext(FiltersContext);
  const closeDatesFilter = () => dispatch({ type: FiltersReducerActions.CLOSE_DATES_FILTER });

  return (
    <Group title={t('filters.sections.dates')}>
      <DateRange
        startName="move-in"
        endName="move-out"
        startLabel={t('filters.labels.moveIn')}
        endLabel={t('filters.labels.moveOut')}
        start={fields['move-in']}
        end={fields['move-out']}
        onChange={onMultiChangeHandler}
        isBarcelona={params && params.city === barcelona}
        shouldOpenDatesFilter={shouldOpenDatesFilter}
        closeDatesFilter={closeDatesFilter}
      />
      <CheckboxFilter
        isNew
        name="instant-bookings"
        value="true"
        onChange={onChangeEventHandler}
        selected={fields['instant-bookings'] === 'true'}
        label={t('global.labels.instant_booking')}
      />
    </Group>
  );
};

Dates.propTypes = {
  fields: PropTypes.object.isRequired,
  onMultiChangeHandler: PropTypes.func.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired
};

export default Dates;
